exports = module.exports = require("../../ngapp/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wysiwyg-font-size-large {\n    font-size: large;\n}\n.wysiwyg-font-size-small {\n    font-size: small;\n}\n.wysiwyg-font-size-x-small {\n    font-size: x-small;\n}\n.wysiwyg-font-size-x-large {\n    font-size: x-large;\n}\n.wysiwyg-font-size-medium {\n    font-size: medium;\n}\n.wysiwyg-text-align-left {\n    text-align: left;\n}\n.wysiwyg-text-align-center {\n    text-align: center;\n}\n.wysiwyg-text-align-justify {\n    text-align: justify;\n}\n.wysiwyg-text-align-right {\n    text-align: right;\n}\n.wysihtml5-editor ul {\n    list-style: none;\n    padding-left: 8px;\n}\n.wysihtml5-editor ul > li:before {\n    content: \"\\2022\";\n    color: #3498DB;\n    margin-right: 12px;\n}\n.wysihtml5-editor hr {\n    border: 1px solid #3498DB;\n    width: 24px;\n    margin-left: 0;\n}\n/*default decorations*/\n.article-basic-defaults {\n    padding: 8px;\n    color: white;\n    font-size: medium;\n    font-family: 'WorkSans-Regular', 'Work Sans', sans-serif;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/developer/Downloads/SleepRestoreBackend/sleep-restore-boot/src/main/resources/static/article.css
// module id = ../../../../../../resources/static/article.css
// module chunks = main